import React, { useState } from "react";
import { Button, Divider, Modal } from "antd";
import { MainText, SubText } from "../../../../helpers/StyledComponents";

const TITLE = "WORKING PRINCIPLES";

const WorkingModal = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="primary"
        onClick={() => setOpen(true)}
        style={{ width: "200px" }}
      >
        <div>{TITLE}</div>
      </Button>
      <Modal
        centered
        open={open}
        onCancel={() => setOpen(false)}
        width={1000}
        footer={null}
      >
        <MainText align="center">{TITLE}</MainText>
        <Divider />
        <SubText indent>
          We seek to exercise the ministries God has given us in obedience to
          our Lord Jesus Christ and in reliance on the Holy Spirit. We therefore
          aim to follow Biblical principles in all that we do and to emphasise
          the vital importance of prayer.
        </SubText>
        <SubText mt="20">
          <strong>
            <i>We approach our work in the following ways:</i>
          </strong>
        </SubText>
        <MainText fs="14" mt="15">
          1. Evangelism and Teaching
        </MainText>
        <SubText mt="10">
          a) We are committed to teaching basic Christian truths as an essential
          part of evangelism.
          <br />
          b) We aim to express God's Good News to children, young people and
          families, not only in words, but also by building caring relationships
          with them.
          <br />
          c) We make every effort to communicate the Gospel in contemporary
          language and in ways appropriate to the context.
          <br />
          d) We emphasise that faith should always lead to action and to growth
          in Christian character and service.
          <br />
          e) We acknowledge that the Gospel has inescapable social dimensions
          and therefore it involves us in service to others and a concern for
          social justice. In view of our specific aims, we have a special
          responsibility for children and young people who are poor, deprived or
          exploited.
          <br />
          f) We encourage children to follow Christ in ways that are appropriate
          to their age, culture and background, taking special account of their
          home and family situation and level of maturity.
          <br />
          g) We believe that the new birth is a profound supernatural
          experience, brought about by the Holy Spirit. So we invite people to
          respond to what he is doing in their lives and guard against calling
          for superficial responses.
          <br />
          h) We are committed to working in ways that reflect our beliefs, in
          appropriate cooperation with organisations and institutions, such as
          schools, that welcome us.
        </SubText>
        <MainText fs="14" mt="15">
          2. Bible Ministries
        </MainText>
        <SubText>
          In encouraging people to meet God through the Bible, we emphasise the
          significance of the Bible as a whole.
          <br />
          a) We encourage people to read it so that they come to repentance,
          faith, obedience to God and worship.
          <br />
          b) We prepare systematic programmes and materials for children, young
          people and adults, appropriate to their age and situation.
          <br />
          c) We are committed to Bible reading which is thoughtful, prayerful
          and regular and which enables the reader to respond to the message of
          the whole Bible rather than to isolated passages.
          <br />
          d) We are concerned to interpret the text in a way which enables
          people, in their contemporary situations, to hear for themselves the
          message of the Bible from its original context.
        </SubText>
        <MainText fs="14" mt="15">
          3. Churches
        </MainText>
        <SubText>
          a) We recognise our part in God's worldwide family and seek ways of
          working positively with a variety of churches.
          <br />
          b) We encourage people who come to faith through our ministries to
          take part in the life of a local church fellowship. tion.
        </SubText>
        <MainText fs="14" mt="15">
          4. Equality and Unity
        </MainText>
        <SubText>
          a) We believe that all human beings are of equal worth in the sight of
          God and that all those who put their faith in Christ are one in him.
          <br />
          b) We are therefore committed to exercising our ministries without
          discrimination as to race, colour, gender, language or social
          position.
          <br />
          c) We recognise that Scripture Union worldwide is a family of national
          movements in which resources can be shared in a responsible way on a
          basis of trust.
          <br />
          d) We express our Christian commitment in varied and creative ways
          since we are drawn from diverse backgrounds.
        </SubText>
        <MainText fs="14" mt="15">
          5. Volunteers and Staff
        </MainText>
        <SubText>
          a) We work with a relatively small number of staff who recruit,
          motivate, train, equip and support a larger number of volunteers with
          whom they work in partnership.
          <br />
          b) We believe that the Holy Spirit confers gifts of leadership on
          Christians of all nations without discrimination. So we encourage
          national leadership of Scripture Union movements, while recognising
          the contribution of those from other countries.
          <br />
          c) We, as staff and volunteers, from a variety of backgrounds, are
          united in our commitment to the aims, beliefs and working principles
          of Scripture Union.
          <br />
          d) We agree that, while we are involved in Scripture Union activities,
          we will handle controversial issues, such as baptism, spiritual gifts
          and church order, in ways that promote harmony.
        </SubText>
        <MainText fs="14" mt="15">
          6. Biblical Standards
        </MainText>
        <SubText>
          a) We aim to follow biblical principles in all that we do. This
          includes, for example, our administration, our publicity and the way
          we care for our staff and volunteers.
          <br />
          b) We seek to honour God in carrying out our ministries, by combining
          prayerful reliance on him with the use of the best available means,
          maintaining the highest standards possible.
          <br />
          c) We believe in praying for financial support, in dependence on God,
          and telling the Christian public of our needs, without distorting the
          truth or using undue pressure.
        </SubText>
      </Modal>
    </>
  );
};

export default WorkingModal;
